import { GeneratorTechnology, GeneratorTypeRef } from './GeneratorReference';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class Genset {

  // Multi only
  public technology: GeneratorTechnology | null = null;

  // Multi only
  public brand: string | null = null;

  // Multi only
  public reference: string | null = null;

  public lifetimeHours: number | null = null;

  public fuelConsumptionAt25Percent: number | null = null;
  public fuelConsumptionAt50Percent: number | null = null;
  public fuelConsumptionAt75Percent: number | null = null;
  public fuelConsumptionAt100Percent: number | null = null;

  // Multi only
  public fuelConsumptionKWhAt25Percent: number | null = null;
  public fuelConsumptionKWhAt50Percent: number | null = null;
  public fuelConsumptionKWhAt75Percent: number | null = null;
  public fuelConsumptionKWhAt100Percent: number | null = null;

  // Multi only
  public efficiencyAt25Percent: number | null = null;
  public efficiencyAt50Percent: number | null = null;
  public efficiencyAt75Percent: number | null = null;
  public efficiencyAt100Percent: number | null = null;

  public optimumPercentage: number | null = null;

  // public averageHours: number | null = null;

  public size: number | null = null;

  // Multi only
  public sizeKW: number | null = null;

  // Multi only
  public pci: number | null = null;

  public typeRef: GeneratorTypeRef | null = null;

  public fromHour: number | null = 0;
  public toHour: number | null = 24;

  // unused
  public numberOfSimultaneous: number | null = 1;

  // unused
  public numberOfSpares: number | null = 0;

  // Multi only
  public addOneThreshold: number | null = null;

  // Multi only
  public rampUpTime: number | null = null;

  // Multi only
  public removeOneThreshold: number | null = null;

  // Multi only
  public srPriority: boolean | null = null;

  public minimumGeneratorLoad: number | null = null;

  // Multi or 1 for Mono
  public quantity: number | null = 1;

  // unused
  public degradation: number | null = 0;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.typeRef = this.typeRef ? (GeneratorTypeRef as any)[this.typeRef] : null;

    this.technology = this.technology ? (GeneratorTechnology as any)[this.technology] : null;
  }
}
